<template>
  <div class="row">
    <div class="filter-holder bg-white shadow-1 col-12">
      <div class="row items-center justify-between q-col-gutter-sm">
        <div class="col-12">
          <div class="row q-col-gutter-sm">
            <div class="col-md-4 col-12">
              <q-input
                v-model.trim="filterData.filterTerms"
                dense
                outlined
                clearable
                :debounce="appSettings.debounceDelay"
                :label="
                  $ts(
                    'modules.esacPoints.esacPointsManagement.redemption.createRedemption.productListFilter.searchPlaceholder'
                  )
                "
                hide-bottom-space
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <q-table
        :data="items"
        :columns="columns"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-options="[]"
        :separator="separator"
        row-key="name"
        :color="appSettings.defaulted.table_color"
        dense
        square
        @request="onRequest"
      >
        <q-tr slot="body" slot-scope="props" :props="props" class="cursor-pointer">
          <q-td v-for="col in props.cols" :key="col.name" :props="props" auto-width>
            <div
              v-if="col.name === 'name'"
              style="width: 500px!important; word-break: break-all; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
            >
              <q-tooltip
                anchor="top middle"
                self="bottom middle"
                :offset="[10, 15]"
                :content-style="{ fontSize: '14px' }"
              >
                {{ props.row.name }}
              </q-tooltip>
              {{ props.row.name }}
            </div>
            <span v-if="col.name === 'action'">
              <q-btn-group v-if="!readOnly && props.row.redeemable" rounded unelevated>
                <q-btn
                  unelevated
                  rounded
                  size="sm"
                  icon="add"
                  color="positive"
                  :disable="readOnly"
                  :label="`( ${getSelectedCampaignItems(props.row).quantity} )`"
                  @click="rowAddCallback(props.row)"
                ></q-btn>
                <q-btn
                  unelevated
                  rounded
                  size="sm"
                  icon="remove"
                  color="negative"
                  :disable="getSelectedCampaignItems(props.row).quantity <= 0"
                  @click="rowRemoveCallback(props.row)"
                ></q-btn>
              </q-btn-group>
              <span v-else>
                {{
                  !readOnly && !props.row.redeemable
                    ? `Insufficient point`
                    : `( ${getSelectedCampaignItems(props.row).quantity} ) Selected`
                }}
              </span>
            </span>
            <span v-else>
              {{ col.value }}
            </span>
          </q-td>
        </q-tr>
        <q-tr>
          <q-td colspan="5"></q-td>
          <q-td class="bg-amber-1 text-bold">{{ getTotalSelectedVoucherPoint }} / ({{ eligibleVoucherPoint }})</q-td>
          <q-td></q-td>
        </q-tr>
        <q-tr v-if="!items.length">
          <q-td colspan="9">
            <empty-list />
          </q-td>
        </q-tr>
        <template slot="top-right" slot-scope="props">
          <qtable-custom-slot-top-right
            :columns="columns"
            :separator.sync="separator"
            :visible-columns.sync="visibleColumns"
            :slot-props="props"
          />
        </template>
      </q-table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { DatesMixin, GeneralsMixin, PaginationMixin } from 'src/application/global/mixins/index'
export default {
  name: 'EsacPointsProductItemsTable',
  mixins: [DatesMixin, PaginationMixin, GeneralsMixin],
  data() {
    return {
      filterData: {
        filterTerms: '',
      },
      loading: false,
      pagination: {
        rowsPerPage: 10,
        page: '',
        rowsNumber: this.productNumber,
      },
      columns: [
        {
          name: 'sku',
          label: this.$ts('table.th.sku'),
          field: row => this.$helpers.getValue(row, 'sku', '-'),
          align: 'left',
          sortable: true,
        },
        {
          name: 'name',
          label: this.$ts('table.th.name'),
          // field: row => this.$helpers.getValue(row, 'name', '-'),
          align: 'left',
          sortable: true,
        },
        {
          name: 'unitPrice',
          label: this.$ts('esacPoints.esacPointsManagement.redemption.tables.th.unitPrice'),
          field: row => this.$helpers.getValue(row, 'price', '-'),
          align: 'left',
          sortable: true,
        },
        {
          name: 'unitEsacPointsPoint',
          label: this.$ts('esacPoints.esacPointsManagement.redemption.tables.th.unitEsacPointsPoint'),
          field: row => this.$helpers.getValue(row, 'price', '-'),
          align: 'left',
          sortable: true,
        },
        {
          name: 'totalUnitPrice',
          label: this.$ts('esacPoints.esacPointsManagement.redemption.tables.th.totalUnitPrice'),
          field: row => this.$helpers.getValue(row, 'price', '-'),
          align: 'left',
          sortable: true,
        },
        {
          name: 'action',
          label: this.$ts('table.th.actions'),
          sortable: true,
        },
      ],
    }
  },
  props: {
    selectedItems: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    eligibleVoucherPoint: {
      type: Number,
      default: 0,
    },
    productNumber: {
      type: Number,
      default: 0,
    },
    filterDataName: {
      type: String,
      default: '',
    },
  },
  watch: {
    filterDataName: {
      handler(newVal, oldVal) {
        this.filterData.filterTerms = newVal
      },
    },
    'filterData.filterTerms': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          setTimeout(() => {
            this.$emit('rowFilterDataCallback', newVal)
          }, 500)
        }
      },
      deep: true,
    },
    productNumber: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.pagination.rowsNumber = newVal
        }
      },
    },
  },
  computed: {
    ...mapGetters(['currencyLabelByCountry']),
    getItems() {
      return this.items.map(item => {
        let availablePoint = this.eligibleVoucherPoint - this.getTotalSelectedVoucherPoint
        let itemUnitPoint = item.price
        return {
          selectable: itemUnitPoint <= availablePoint,
          ...item,
        }
      })
    },
    getTotalSelectedVoucherPoint() {
      return _.sumBy(this.selectedItems, function(item) {
        return item.price * item.quantity
      })
    },
  },
  mounted() {
    this.filterData.filterTerms = this.filterDataName
  },
  methods: {
    getSelectedCampaignItems(row) {
      let { type, id } = row
      let item =
        this.selectedItems.find(x => x.id === id && x.type === type) ||
        this.items.find(x => x.id === id && x.type === type)
      return {
        quantity: 0,
        // max_quantity: 0,
        is_foc: false,
        ...item,
      }
    },
    rowAddCallback(row) {
      this.$emit('rowAddCallback', row)
    },
    rowRemoveCallback(row) {
      this.$emit('rowRemoveCallback', row)
    },
    onRequest(props) {
      this.$emit('rowPaginationCallback', props.pagination)
      setTimeout(() => {
        this.pagination.page = props.pagination.page
      }, 500)
    },
  },
}
</script>
